export const SET_CONFIG_INVALID_TOKEN = "error/SET_CONFIG_INVALID_TOKEN";
